<template>
  <header class="menu">
    <div class="toggle-saldo-container">
      <button class="toggle-button" @click="toggleCoreSidebar" v-if="idRole != 3">
        <img src="/icons/menu.svg" alt="Toggle Menu Icon">
      </button>
      <SaldoDisplay />
    </div>
    <div class="nav-actions">
      <NotificationDropdown v-if="idRole == '1' || idRole == '5'" />
      <div>
        <div>
          <div class="perfil">
            <div class="content">
              <i class="fa fa-user-circle"></i>
              <div class="infos">
                <strong>{{ perfil.nome }}</strong>
                <span>{{ perfil.funcao }}</span>
              </div>
            </div>
            <i class="fa fa-angle-down"></i>
          </div>
          <vuestic-dropdown v-model="isShown" position="bottom" class="perfil-dropdown">
            <template v-if="idRole == 4">
              <router-link :to="{ name: 'aluno' }" class="dropdown-item">
                <img src="/icons/perfil.svg" alt="Icone de perfil">
                Perfil
              </router-link>
            </template>
            <template v-if="schema == 'public'">
              <router-link :to="{ name: 'permissoes' }" class="dropdown-item">
                <img src="/icons/configuracoes.svg" alt="Icone de perfil">
                Configurações
              </router-link>
            </template>
            <template v-if="idRole == 1">
              <router-link :to="{ name: 'listagem-salas' }" class="dropdown-item">
                <img src="/icons/salas.svg" alt="Icone de perfil">
                Salas
              </router-link>
              <router-link :to="{ name: 'listagem-cameras' }" class="dropdown-item">
                <img src="/icons/camera.svg" alt="Icone de perfil">
                Câmeras
              </router-link>
            </template>
            <button @click="logout" class="dropdown-item red">
              <img src="/icons/sign-out.svg" alt="Icone de logout">
              Sair
            </button>
          </vuestic-dropdown>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

import { Auth } from '../../services/auth'
import NotificationDropdown from '../notifications/NotificationDropdown.vue';
import SaldoDisplay from './SaldoDisplay.vue';

export default {
  components: {
    NotificationDropdown,
    SaldoDisplay,
  },
  data() {
    return {
      isShown: false,
      isNotificationsShow: false,
      aula: '',
      profileShow: false,
      idRole: localStorage.id_role,
      schema: localStorage.schema
    };
  },
  methods: {
    toggleCoreSidebar() {
      this.$emit('toggleCoreSidebar')
    },
    logout() {
      switch (this.idRole) {
        case 3:
          return Auth.logoutInstrutor()
        case 4:
          return Auth.logoutAluno()
        default:
          return Auth.logout()
      }
    },
  },
  computed: {
    perfil() {
      const user = JSON.parse(localStorage.usuario)

      let funcao = ''

      switch (user.id_funcao_usuario) {
        case 1:
        case 5:
          funcao = 'Admin'
          break
        case 2:
        case 7:
          funcao = 'Suporte'
          break
        case 3:
          funcao = 'Instrutor'
          break
        case 4:
          funcao = 'Aluno'
          break
        case 6:
          funcao = 'Financeiro'
          break
        case 8:
          funcao = 'Comercial'
          break
        case 9:
          funcao = 'DETRAN'
          break
      }

      return {
        ...user,
        funcao,
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle-saldo-container {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  // Responsivo: empilha em telas pequenas
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    .saldo-display {
      margin-left: 0 !important;
    }
  }
}
.menu {
  flex: 1;
  max-height: 4.375rem;
  padding: 1rem 1.875rem;
  background: #FFFFFF;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .toggle-button {
    all: unset;
    padding: 0.40625rem 0;

    cursor: pointer;

    img {
      width: 1.5rem;
      height: 1.5625rem;
    }
  }
}

.perfil {
  display: flex;
  align-items: center;
  gap: 1rem;

  cursor: pointer;

  .content {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .fa-user-circle {
      font-size: 2.375rem;
    }

    .infos {
      display: flex;
      flex-direction: column;
      gap: 0.1875rem;

      strong {
        font-size: 0.875rem;
        font-weight: bold;
        color: #404040;
      }

      span {
        font-size: 0.75rem;
        font-weight: 600;
        color: #565656;
      }
    }
  }

  .fa-angle-down,
  .fa-angle-up {
    padding: 0.1rem 0.3rem;
    border: 1px solid #5C5C5C;
    border-radius: 9999px;
  }
}

.perfil-dropdown {
  width: 13.1875rem;
  border: 1px solid #E4E4E4;
  border-radius: 14px;
  background: #FFF;
  box-shadow: none;

  display: flex;
  flex-direction: column;

  font-weight: 600;

  .dropdown-item:not(:last-child) {
    border-bottom: 0.5px solid #E4E4E4;
  }

  .dropdown-item {
    all: unset;
    padding: 0.75rem 1.25rem;

    display: flex;
    align-items: center;
    gap: 0.5rem;

    font-size: 0.875rem;
    font-weight: 600;

    cursor: pointer;

    &:hover {
      background: #F2F2F2;
    }

    &.red {
      color: #E91D23;
    }

    img {
      width: 1.125rem;
      height: 1.125rem;
    }
  }
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 2.5rem;
}
</style>
